import API from './api';

export async function getCode(code) {
  const { data } = await API.get(`/codes/${code}`);
  return data;
}